<template>
  <div class="layout-box">
    <LayoutHeader headtitle="仓储云眸" :permissions="[1]"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <div class="bread-crumb-nav">当前位置：<a @click="$router.go(-1)">首页</a> > 仓储云眸</div>
      </div>
      <div class="news-list">
        <span class="news-list-tit"><i class="iconfont icon-jiankongshexiangtou-xianxing"></i> 仓储列表</span>
        <ul>
          <li v-for="(item,index) in datas" @click="ckxq(item.place)" :key="index" :class="choosedata.place==item.place?'on':''"><em>{{index+1}}</em><a>{{item.place}}</a></li>
        </ul>
        <div class="analyse-chart" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 6px; left: 0; width: 100%; text-align: center; font-size: 12px; color: #fff">PTA注册仓单情况</h3>
          <div id="machartlinepta2" style="width: 100%; height: 100%"></div>
        </div>
        <div class="analyse-chart" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 6px; left: 0; width: 100%; text-align: center; font-size: 12px; color: #fff">PTA仓单情况</h3>
          <div id="machartlinepta" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <ul class="experts-list clear">
        <li v-for="(item,index) in choosedata.stronghold" :key="index">
          <div :id="'video-container'+index" class="videos"></div>
          <div class="tits">位置：{{item.name}}</div>
          <div class="operation-video">
            <span>
              <em title="播放" class="iconfont" :class="(playerobj.obj==index&&playerobj.starts)?'icon-zanting stopred':'icon-bofang'"  @click="stopvideo(index)"></em>
              <em title="截图" class="iconfont icon-screenshot" style="font-size: 38px" @click="capturePicture(index)"></em>
<!--              <em title="录屏" class="iconfont icon-a-luxiang2" style="font-size: 34px"></em>-->
            </span>
            <em title="全屏" class="iconfont icon-quanping" style="font-size: 28px" @click="fullScreen(index)"></em>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
import EZUIKit from 'ezuikit-js'
export default {
  name: 'StorageVideo',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      datas:[
        {place:'临港仓储大门',stronghold:[
          {name:'大门口朝北',serial:'G16830934',id:4},
          {name:'大门口朝南',serial:'G16830934',id:2},
            // {name:'#1仓右角大门方向',serial:'G16830930',id:1},
            // {name:'#2仓右角大门方向',serial:'G16830930',id:7},
          {name:'大门口',serial:'G16830934',id:1},
          {name:'#1-4仓南向北',serial:'G16830922',id:19}
          ]},
        {place:'临港仓储地磅',stronghold:[
            {name:'地磅朝东',serial:'G16830934',id:14},
            {name:'地磅朝西',serial:'G16830934',id:13},
            {name:'#2-3仓通道北向南',serial:'G16830922',id:8},
            {name:'#2-3仓通道南向北',serial:'G16830922',id:15},
          ]},
        // {place:'临港仓储1-4',stronghold:[
        //     {name:'仓南向北',serial:'G16830922',id:19}
        //   ]},
        // {place:'临港仓储2-3',stronghold:[
        //     {name:'仓通道北向南',serial:'G16830922',id:8},
        //     {name:'仓通道南向北',serial:'G16830922',id:15},
        //   ]},
        {place:'临港仓储3-6',stronghold:[
            {name:'#3-6仓通道北向南',serial:'G16830922',id:10},
            {name:'#3-6仓通道南向北',serial:'G16830922',id:26},
            {name:'#4-5仓通道北向南',serial:'G16830922',id:29},
            {name:'#4-5仓通道南向北',serial:'G16830922',id:21},
          ]},
        // {place:'临港仓储4-5',stronghold:[
        //     {name:'仓通道北向南',serial:'G16830922',id:29},
        //     {name:'仓通道南向北',serial:'G16830922',id:21},
        //   ]},
        {place:'临港仓储2#、6#',stronghold:[
            {name:'2#东北角围墙朝西',serial:'G16830922',id:5},
            {name:'2#西南角朝西',serial:'G16830922',id:13},
            {name:'6#西南角朝南',serial:'G16830922',id:2},
            {name:'6#东北角朝东',serial:'G16830922',id:3},
          ]},
        {place:'临港仓储3#、5#',stronghold:[
            {name:'3#北围墙朝西',serial:'G16830922',id:7},
            {name:'3#东北角朝东',serial:'G16830922',id:14},
            {name:'3#西南角朝西',serial:'G16830922',id:30},
            {name:'5#东北角朝东',serial:'G16830922',id:17},
          ]},
        // {place:'临港仓储5#',stronghold:[
        //     {name:'东北角朝东',serial:'G16830922',id:17},
        //   ]},
        // {place:'临港仓储6#',stronghold:[
        //     {name:'西南角朝南',serial:'G16830922',id:2},
        //     {name:'东北角朝东',serial:'G16830922',id:3},
        //   ]},
      ],
      accessToken:'at.cs16uvd77xm75l7z0myqlk3yaidqbx51-231baziklc-0s49w9d-ajlryrbxc',
      choosedata:{place:'',stronghold:[]},
      player: {player0:null,player1:null,player2:null,player3:null},
      playerobj: {obj:null,starts:false},
      loading:true,
      loading2:true,
    }
  },
  mounted() {
    const urls = '/api-portal/token/flushToken';
    this.$api.post(urls, {}, (response) => {
      this.accessToken = response.data.data
      this.ckxq('临港仓储大门',true)
    })
    let $this = this
    $this.getdata()
    $this.dataRefresh.$ons('Refresh', () => {
      $this.player['player0'].stop()
      $this.getdata()
      setTimeout(function () {
        $this.player['player0'].play()
      },2000)
    })
  },
  methods: {
    getdata(){
      const $this=this
      const url = '/api-portal/hPtaDetail/ptawarehouse';
      $this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datad=datas.data
          let arr=[]
          datad.dataList.map(val=>{
            arr.push({
              data: val.dataValue,
              type: 'line',
              connectNulls:true,
              name:val.yearStr,
              showSymbol: false,
            })
          })
          $this.drawchartones2(datad.dateX,arr)
        }
      })
      const url2 = '/api-portal/hPtaDetail/ptawarehousesituation';
      $this.$api.post(url2, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datad=datas.data
          $this.drawchartones(datad.dateX,datad.dataList[0].dataValue,datad.dataList[0].typeName,datad.dataList[1].dataValue,datad.dataList[1].typeName)
        }
      })
    },
    ckxq(placename,inte){
      let $this=this
      // $this.removevideo()
      let getdata=$this.datas[$this.datas.findIndex((item) => item.place === placename)]||{}
      $this.choosedata=getdata
      if(inte){
        $this.ezuikitplayer(getdata.stronghold)
      }else{
        $this.cutvideo(getdata.stronghold)
      }
    },
    ezuikitplayer(stronghold){
      var $this=this
      var len=stronghold.length
      var accessToken=this.accessToken
      if(len>0){
        $this.playerobj.starts=true
        $this.playerobj.obj=0
        for(let i=0;i<len;i++){
          var serial=stronghold[i].serial
          var ids=stronghold[i].id
          setTimeout(
            (ar)=>{
              if(ar.n>1){
                $this.player['player'+(ar.n-1)].stop();
              }
              $this.player['player'+ar.n]= new EZUIKit.EZUIKitPlayer({
                id: 'video-container'+ar.n, // 视频容器ID
                accessToken: accessToken,
                url: 'ezopen://open.ys7.com/'+ar.bh+'/'+ar.id+'.hd.live',
                template: 'simple', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版; theme-可配置主题；
                // plugin: ['talk'],                       // 加载插件，talk-对讲
                width: 607,
                height: 400,
              });
              if(ar.n==(ar.maxl-1)){
                setTimeout(function () {
                  $this.player['player'+ar.n].stop();
                },3000)
                $this.player['player0'].play();
              }
            },i*2500, {n:i,id:ids,bh:serial,maxl:len})
        }
      }
    },
    stopvideo(n){
      let $this=this;
      let newn=$this.playerobj.obj
      if(newn!=null&&newn!=n){
        let playr=this.player['player'+newn]
        playr.stop();
        $this.playerobj.starts=false
      }
      let st=$this.playerobj.starts
      let playr2=this.player['player'+n]
      $this.playerobj.obj=n
      if(st){
        playr2.stop();
        $this.playerobj.starts=false
      }else {
        playr2.play();
        $this.playerobj.starts=true
      }
    },
    capturePicture(n) {
      let playr=this.player['player'+n]
      playr.capturePicture('Monitorimg');
    },
    fullScreen(n) {
      let playr=this.player['player'+n]
      playr.fullScreen(true);
    },
    startSave() {
      let playr=this.player['player'+n]
      playr.startSave();
    },
    cutvideo(stronghold){
      var $this=this
      let datas=stronghold
      var len=datas.length
      if(len>0) {
        $this.playerobj.starts = true
        $this.playerobj.obj = 0
        for(let i=0;i<len;i++){
          let serial=datas[i].serial
          let ids=datas[i].id
          $this.player['player'+i].play({
            url: 'ezopen://open.ys7.com/'+serial + '/' + ids + '.hd.live',
          }).then((ada)=>{
            if(i>0){
              setTimeout(function () {
                $this.player['player'+i].stop()
              },500)
            }
          })
        }
      }
    },
    removevideo(){
      let $this=this
      var stronghold=$this.choosedata.stronghold
      let lens=stronghold.length
      //初始化视频区域
      $this.player= {player0:null,player1:null,player2:null,player3:null}
      if(lens>0){
        for(var i=0;i<lens;i++){
          var ids=stronghold[i].id
          document.getElementById('video-container'+ids).innerHTML=''
        }
      }
    },
    drawchartones(data1,data2,name2,data3,name3){
      const myEchartst = this.$echarts.init(document.getElementById('machartlinepta'))
      let option = {
        tooltip:{
          show:true,
          trigger: 'axis',
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${(item.data/10000).toFixed(1)} 万`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          },
          textStyle:{
            fontSize:12
          }
        },
        color:['#2E88FF','#FE8433','#1FD3CD','#6D6DF2'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '2%',
          top: '30%',
          containLabel: true
        },
        legend: {
          show: true,
          left: 'center',
          top: 30,
          textStyle: {
            color: '#CDCDD0'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#C0C0C4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: data1
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show:false,
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:'#252636'
              }
            },
            axisLabel: {
              color: '#C0C0C4',
              formatter: function (params) {
                return parseInt(params/10000)+'万'
              }
            }
          },{
            type: 'value',
            splitLine: {
              show:false,
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:'#252636'
              }
            },
            axisLabel: {
              color: '#C0C0C4',
              formatter: function (params) {
                return parseInt(params/10000)+'万'
              }
            }
          }
        ],
        series: [
          {
            data: data2,
            type: 'line',
            yAxisIndex:0,
            name:name2,
            showSymbol: false,
          },
          {
            data: data3,
            type: 'line',
            yAxisIndex:1,
            name:name3,
            showSymbol: false,
          }
        ]
      }
      myEchartst.setOption(option)
      this.loading=false
    },
    drawchartones2(data1,data2){
      const myEchartst = this.$echarts.init(document.getElementById('machartlinepta2'))
      let option = {
        tooltip:{
          show:true,
          trigger: 'axis',
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${(item.data/10000).toFixed(1)} 万`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          },
          textStyle:{
            fontSize:12
          }
        },
        color:['#2E88FF','#FE8433','#1FD3CD','#6D6DF2'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '2%',
          top: '30%',
          containLabel: true
        },
        legend: {
          show: true,
          left: 'center',
          top: 30,
          textStyle: {
            color: '#CDCDD0'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#C0C0C4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: data1
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show:false,
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#252636'
            }
          },
          axisLabel: {
            color: '#C0C0C4',
            formatter: function (params) {
              return parseInt(params/10000)+'万'
            }
          }
        },
        series: data2
      }
      myEchartst.setOption(option)
      this.loading2=false
    }
  },
  beforeDestroy(){
    this.removevideo()
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 160px);
  padding-top: 160px;
  overflow: auto;
  background: url("../../assets/erj_bj.fw.png");
}

.layout-box::-webkit-scrollbar{
  display: none;
}

.secondary-content{
  width: 1300px;
  margin: 0 auto;
  margin-left: calc(50% - 460px);
  position: relative;
  background: #0A47B6;
  min-height: calc(100% - 20px);
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.bread-crumb-nav{
  font-size: 16px;
  color: #fff;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.experts-list{
  padding: 10px 0 0 10px;
}


.experts-list li{
  width: 606px;
  height: 400px;
  padding: 10px;
  margin: 0 8px 15px 8px;
  background: #0D347A;
  cursor: pointer;
  position: relative;
  box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  float: left;
}

.tits{
  position: absolute;
  z-index: 999;
  top: 9px;
  left: 10px;
  padding: 10px;
  background: linear-gradient(to left,rgba(0,0,0,.6),rgba(0,0,0,0),rgba(0,0,0,0));
  width: calc(100% - 38px);
  text-align: right;
  color: #fff;
}

.operation-video{
  position: absolute;
  z-index: 999;
  bottom: 9px;
  left: 10px;
  padding: 10px;
  background: rgba(0,0,0,.7);
  width: calc(100% - 38px);
  color: #fff;
  display: flex;
  justify-content: space-between;
}

.operation-video em{
  font-size: 32px;
  font-weight: bold;
  padding: 3px 12px;
  opacity: 0.7;
}

.operation-video em:hover{
  opacity: 1;
}

.videos{
  width: 607px;
  height: 400px;
  background: #000 url("../../assets/loading.jpg") no-repeat center center;
}

.news-list{
  width: 360px;
  position: fixed;
  height: calc(100% - 180px);
  top: 160px;
  left: 50%;
  margin-left: -840px;
  background: #0A47B6;
}

.news-list-tit{
  background: #103E92;
  display: block;
  width: calc(100% - 40px);
  color: #fff;
  margin: 12px auto;
  font-size: 16px;
  line-height: 32px;
  box-sizing: border-box;
  padding: 5px 10px;
  box-shadow: 1px 2px 4px 0 rgba(0,0,0,.2);
}

.news-list em{
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  color: #0A47B6;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  margin-right: 5px;
  vertical-align: top;
  margin-top: 1px;
}

.news-list .on{
  background: #07358B;
  border-radius: 6px;
}

.news-list .on em{
  font-weight: bold;
  color: #0E2E68;
}

.news-list a{
  color: #fff;
  width: calc(100% - 26px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  cursor: pointer;
}

.news-list a:hover{
  text-decoration: underline;
}

.news-list ul{
  margin: 5px 20px;
  height: calc(100% - 480px);
  position: relative;
  background: #103E92;
  box-shadow: 1px 2px 4px 0 rgba(0,0,0,.2);
  overflow: auto;
  margin-bottom: 15px;
}

.stopred{
  color: #f00;
}

.news-list ul::-webkit-scrollbar{
  display: none;
}

.news-list li{
  padding: 10px 0 10px 10px;
}
.analyse-chart{
  width: 100%;
  height: 195px;
  margin-top: 9px;
  background: #050514;
  overflow: hidden;
  position: relative;
}

iframe{
  /*width: 100%;*/
  /*height: 100%;*/
  border: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 400px;
  height: 216.67px;
  transform: scale(0.9) translate(-50%, -50%);
  transform-origin: 0 0;
}
</style>




// WEBPACK FOOTER //
// src/views/secondary/storage-video.vue